import React, { useEffect, useState ,useContext} from "react";
import "./Profilepop.css";
import common from "../config/common.json"
import { LoadingSpinner } from "../loadingSpinner/LoadingSpinner";
import getGlobalVarContext from "../context/getGlobalVarContext";
import {useIntl} from 'react-intl';



function General() {
  const [isLoading, setIsLoading] = useState(false);
  const intl = useIntl()

  var requestOptions = {
    method: "GET"
  };
  const { globalVar,setGlobalVar} = useContext(getGlobalVarContext());
  const {email,userDetalis}= globalVar
  
  useEffect(() => {
    setIsLoading(true);
  console.log("======")
  if(userDetalis === null){
    fetch(
      `${common.BASEURL}/user/details?email=${email !==null ?email:localStorage.getItem("email")}`,
      requestOptions
    )
      .then(response => response.json())
      .then(result => {
        var list = [];
        list.push(result.msg);
        setIsLoading(false);
        setGlobalVar((oldData) => ({
          ...oldData,
          userDetalis: result.msg,
        }));
      })
      .catch(error => console.log("error", error));
    }else{
      setIsLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : 
        <div className="profilepop current_plan">
          <div className="profilepop_form curent_pla_left">
            <div className="withextra">
              <div className="leftbill">
                <div className="profiledatapadding">
                    <label>{intl.formatMessage({id: "paymentInfoLableName" })}</label>
                    <br/>
                    <h5>
                      {userDetalis?.first_name} {userDetalis?.last_name}
                    </h5>
                  </div>
                  <div className="profiledatapadding">
                    <label>{intl.formatMessage({id: "paymentInfoLableActivePlan" })}</label>
                    <br/>
                    <h5> {userDetalis?.plan}</h5>
                  </div>
                  <div className="profiledatapadding">
                    <label>{intl.formatMessage({id: "paymentInfoLableEmail" })}</label>
                    <br/>
                    <h5> {userDetalis?.email}</h5>
                  </div>
                  <div className="profiledatapadding">
                      <label>{intl.formatMessage({id: "paymentInfoLableBillingAddress" })}</label>
                      <br/>
                      <h5>{userDetalis?.line1}</h5>
                  </div>
                  <div className="profiledatapadding">
                      <label>{intl.formatMessage({id: "paymentInfoLableKonnectNumber" })}</label>
                      <br/>
                      <h5>{localStorage.getItem('k_username')}</h5>
                  </div>
                  {localStorage.getItem('k_phone_number') !=="undefined"?
                  <div className="profiledatapadding">
                      <label>{intl.formatMessage({id: "paymentInfoLablePhoneNumber" })}</label>
                      <br/>
                      <h5>{localStorage.getItem('k_phone_number') !== "undefined"?localStorage.getItem('k_phone_number'):""}</h5>
                  </div>
                  :""}
              </div>
            </div>
            
          </div>
        </div>
      }
    </>
  );
}
export default General;
